import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FundService } from 'src/app/services/fund/fund.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-dashboard-fund-approval-quotas',
  templateUrl: './dashboard-fund-approval-quotas.component.html',
  styleUrls: ['./dashboard-fund-approval-quotas.component.scss'],
})
export class DashboardFundApprovalQuotasComponent implements OnInit {
  showQuotaDetails: boolean = false;
  selectedQuota: any = null;

  canView = false;

  quotas: any[] = [];
  loading = true;
  data;

  constructor(
    public fundService: FundService,
    private api: ApiService,
    private route: ActivatedRoute,
    private toast: ToastService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    if (this.fundService.fundData.quotas) {
      this.data = this.fundService.fundData.quotas;
      this.quotas = this.data.quota_series;
      this.loading = false;
    } else {
      this.getFundData();
    }

    this.canView = this.authService.verifyPermission(
      'de_can_view_fund_quote_details'
    );
  }

  getChoicesName(object: string, value: any) {
    const choices = this.fundService.choices;

    const choiceObject = choices[object];

    if (choiceObject) {
      return choiceObject.find((_choice: any) => _choice.value == value);
    }

    return { label: '', value: '' };
  }

  handleOpenQuota(i) {
    this.showQuotaDetails = true;
    this.selectedQuota = i;
  }

  closeModal() {
    this.showQuotaDetails = false;
    this.selectedQuota = null;
  }

  async getFundData() {
    try {
      const data = await this.api.get({
        route: 'api/v2/approvals/version/',
        params: {
          fund: this.route.snapshot.params.id,
          tab: 'quotas',
        },
        token: true,
      });

      const fund = { ...data };

      if (fund[0].fund && fund[0].fund.length === 0) {
        this.loading = false;
        return;
      }

      this.data = fund[0].fund[0];
      this.quotas = this.data.quota_series;

      this.fundService.fundData = {
        ...this.fundService.fundData,
        quotas: fund[0].fund[0],
      };
    } catch (error) {
      this.toast.show('error', 'Erro', 'Erro ao carregar cotas: ' + error);
    }

    this.loading = false;
  }
}
